import React from 'react';
import Badge from '../../common/Badge';
import Button from '../../common/Button';
import '../../../styles/Auction.css';

const AuctionRoomHeader = ({ highest, session, participantCount, timeLeft, onLeave }) => {
    const currentPrice = highest ? highest.amount : (session?.starting_price || 0);
    const isLive = session?.status === 'active';

    return (
        <div className="auction-room-header">
            <div className="header-left">
                <Button
                    onClick={onLeave}
                    variant="ghost"
                    size="sm"
                    className="leave-room-btn"
                >
                    ← Leave Room
                </Button>
                <h2>{session?.token_symbol || 'Auction Room'}</h2>
                <div className="session-meta">
                    <Badge variant={isLive ? 'live' : 'neutral'}>
                        {isLive ? 'Live' : (session?.status || 'Active')}
                    </Badge>
                    {/* --- Countdown Timer Display --- */}
                    {isLive && timeLeft && (
                        <div className="auction-countdown-header">
                            <span className="countdown-label">Ends In:</span>
                            <span className="countdown-value tabular-nums font-mono">{timeLeft}</span>
                        </div>
                    )}
                    <span className="session-id tabular-nums font-mono">
                        ID: {session?.session_id}
                    </span>
                    <span className="participant-badge">
                        <span className="icon">👥</span>
                        <span className="count tabular-nums font-mono">{participantCount || 0}</span>
                        <span className="label">Participants</span>
                    </span>
                </div>
            </div>

            <div className="header-right">
                <div className="current-bid-label">Current Highest Bid</div>
                <div className="current-bid-amount tabular-nums font-mono">
                    ${parseFloat(currentPrice).toLocaleString()}
                </div>
            </div>
        </div>
    );
};

export default AuctionRoomHeader;